import React, { useEffect } from "react";
import { useLazyGetprofileQuery } from "../State/Api/AdddocApiSlice";
import { MdOutlineEmail, MdOutlinePhone } from "react-icons/md";


const DoctorsideProfile = () => {
  const uniqueUserId = localStorage.getItem("userUniqueID");
  const [fetchProfile, { data: profileData, isFetching, isError }] =
    useLazyGetprofileQuery();

  useEffect(() => {
    if (uniqueUserId) {
      fetchProfile(uniqueUserId);
    }
  }, [uniqueUserId]);

  const profileStyles = `
  .doctor-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    margin-top: 2rem;
    width: 100%;
  }

  .doctor-card-header {
    position: relative;
    height: 220px;
    background-color: #f0f0f0;
  }

  .header-background {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .avatar-section {
    position: absolute;
    top: 140px;
    left: 30px;
    display: flex;
    gap: 16px;
    align-items: flex-start;
    flex-direction:column;
  }

  .doctor-avatar {
    width: 110px;
    height: 110px;
    border-radius: 50%;
    border: 4px solid #fff;
    object-fit: cover;
    background: #f1f1f1;
  }

  .doctor-info {
    margin-top: 40px;
  }

  .doctor-info h3 {
    font-size: 1.25rem;
    margin: 0;
  }

  .badge {
    font-size: 0.7rem;
    background: #e6f2ff;
    color: #007bff;
    padding: 3px 8px;
    border-radius: 6px;
    margin-left: 8px;
    display:flex;
    align-items:center
  }

  .clinic-name {
    color: #777;
    font-size: 0.9rem;
    margin: 0;
  }

  .meta-info {
    display: flex;
    gap: 1rem;
    font-size: 0.8rem;
    color: #666;
    margin-top: 4px;
    align-items:center
  }

  .doctor-card-body {
    padding: 10px 20px 20px;
    width: 100%;
    
  }

  .section {
    margin-bottom: 1.5rem;
    margin-top: 40px;
  }

  .section h6 {
  font-size: 1rem;
  margin-bottom: 1rem;
}

.section .px-2 div {
  font-size: 0.9rem;
  color: #333;
}

  .experience-card {
    border:1px solid lightgray;
    padding: 15px;
    border-radius: 10px;
    font-size: 0.9rem;
  }

  .see-more {
    color: #007bff;
    cursor: pointer;
  }

  .medical-actions {
    background: #f8f8f8;
    border-radius: 8px;
    padding: 16px;
    max-height: 250px;
    overflow-y: auto;
    box-shadow: inset 0 0 5px rgba(0,0,0,0.05);
    
  }

  ul.list-unstyled {
    padding-left: 0;
    list-style: none;
  }

  .list-unstyled li {
    padding: 6px 0;
    font-size: 0.9rem;
    border-bottom: 1px solid #e6e6e6;
  }
    .medical-actions-card {
  background: #f8f9fa;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

.custom-dot-list {
  list-style-type: disc;
  padding-left: 1.2rem;
  margin: 0;
}

.custom-dot-list li {
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
  color: #333;
}

  /* Responsive */
  @media (max-width: 768px) {
    .avatar-section {
      flex-direction: column;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      top: 140px;
    }

    .doctor-info {
      text-align: center;
      margin-top: 12px;
    }

    .doctor-card-body {
      padding: 120px 1rem 1rem;
    }
  }
  `;

  return (
    <>
      <style>{profileStyles}</style>
      {profileData && (
        <div className="container-fluid px-3 mb-5">
          <div className="doctor-card">
            <div className="doctor-card-header">
              <img
                src="https://images.pexels.com/photos/414612/pexels-photo-414612.jpeg?cs=srgb&dl=pexels-souvenirpixels-414612.jpg&fm=jpg"
                alt="Header"
                className="header-background"
              />
              <div className="avatar-section">
                <img
                  src={profileData?.basicinfo?.imageURL}
                  alt="Doctor"
                  className="doctor-avatar"
                />
              </div>
            </div>
            <div className="row doctor-card-body">
              <div className="col-md-8">
                <div
                  className="doctor-info"
                  style={{
                    borderBottom: "1px solid lightgray",
                    paddingBottom: "10px",

                  }}
                >
                  <div className="d-flex">
                    <span className="me-2">
                      <h3>{profileData?.basicinfo?.fullname}</h3></span> <p style={{ fontSize: '12px', display: 'flex', alignItems: 'end' }}>{profileData?.eductioncertificates?.map(e => e.qualification).join(", ")}</p>
                    <span className="badge">
                      {profileData?.professionalinfo?.specialization}
                    </span>

                  </div>
                  <p className="clinic-name">
                    {profileData?.basicinfo?.clinic_Hospital_Name}, {profileData?.basicinfo?.office_clinicaddress}
                  </p>
                  <div className="meta-info">
                    <span
                        className={`px-3 py-1 rounded-full text-white text-xs font-semibold ${
                          profileData?.basicinfo?.isactive === "Available"
                            ? "bg-green-500"
                            : "bg-red-500"
                        }`}
                      >
                        {profileData?.basicinfo?.isactive || "-"}
                      </span>
                    <span style={{display:'flex',alignItems:'center',gap:5}}><MdOutlineEmail />{profileData?.basicinfo?.emailaddress}</span>
                    <span style={{display:'flex',alignItems:'center',gap:5}}><MdOutlinePhone />{profileData?.basicinfo?.phonenumber}</span>
                  </div>
                </div>

                <div
                  className="section-thfghj mt-3"
                  style={{
                    borderBottom: "1px solid lightgray",
                    paddingBottom: "10px",
                  }}
                >
                  <h5 className="h5 fw-bold">Doctor Profile</h5>
                 <p>
    {profileData && (
      <>
        With a distinguished career of{" "}
        {profileData?.professionalinfo?.experience || "several"}{" "}
        years, {profileData?.basicinfo?.fullname}, a{" "}
        {profileData?.professionalinfo?.specialization || "medical specialist"},{" "}
        brings extensive expertise in diagnosing and treating a wide range of
        conditions. Certified in{" "}
        {profileData?.eductioncertificates
          ?.map((edu) => edu?.qualification)
          .join(", ") || "relevant medical fields"}, and affiliated with{" "}
        {profileData?.professionalinfo?.professionalaffiliations || "prestigious institutions"},{" "}
        {profileData?.basicinfo?.fullname} is committed to providing
        high-quality patient care.
      </>
    )}
  </p>
                </div>

                <h5 className="h5 fw-bold mt-3">Education Details</h5>
                {profileData?.eductioncertificates?.map((edu, index) => (
                  <div className="experience-card mb-3 mt-2" key={index}>
                    <strong>
                      {edu?.university} - {edu?.qualification}
                    </strong>
                    <span className="d-flex gap-1"><p className="fw-semibold">Field:</p> {edu?.fieldofStudy}</span>
                    <p>
                      {new Date(edu?.startdate).toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      }).replace(/ /g, "-")}{" "}
                      -{" "}
                      {new Date(edu?.lastdate).toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      }).replace(/ /g, "-")}
                    </p>
                    <span className="d-flex gap-1"><p className="fw-semibold">Percentage:</p> {edu?.percentages}%</span>
                    <span className="d-flex gap-1"><p className="fw-semibold">Certifications:</p> {edu?.certifications}</span>
                  </div>
                ))}
              </div>

              <div className="col-md-4">
               <div className="section">
  <h5 className="h5 fw-bold mb-3">Availability Timings</h5>
  <div className="medical-actions-card p-3 border rounded">
    {profileData?.clinicalrole?.timings?.length > 0 ? (
      <ul className="custom-dot-list">
        {profileData.clinicalrole.timings.map((day, index) => {
          // Helper function to convert HH:MM:SS → HH:MM AM/PM
          const formatTime = (timeStr) => {
            if (!timeStr) return null;
            const [hour, minute] = timeStr.split(":");
            const h = parseInt(hour, 10);
            const ampm = h >= 12 ? "PM" : "AM";
            const hour12 = h % 12 === 0 ? 12 : h % 12;
            return `${hour12}:${minute} ${ampm}`;
          };

          return (
            <li key={index}>
              <strong>{day.weekdayName}:</strong>{" "}
              {day.startTime && day.endTime
                ? `${formatTime(day.startTime)} - ${formatTime(day.endTime)}`
                : "N/A"}
              {day.startTime1 && day.endTime1
                ? `, ${formatTime(day.startTime1)} - ${formatTime(day.endTime1)}`
                : ""}
            </li>
          );
        })}
      </ul>
    ) : (
      <p style={{ fontStyle: "italic", color: "#888" }}>
        Doctor is not available
      </p>
    )}
  </div>
</div>


              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DoctorsideProfile;
